import React from 'react';
import CardBody from 'components/Card/CardBody';
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
import { useTranslation } from 'react-i18next';
import { Divider, FormLabel } from '@material-ui/core';
import CardWrapper from 'components/Card/CardWrapper';
import { makeStyles } from '@material-ui/styles';
import LabeledCheckbox from 'components/Checkbox/LabeledCheckbox';
import NumberFormat from 'react-number-format';
import FormTextInputNoGrid from 'components/FormTextInput/FormTextInputNoGrid';
import extendedFormsStyle from 'assets/jss/material-dashboard-pro-react/views/extendedFormsStyle';
import InfoIconTooltip from 'components/InfoIconTooltip/InfoIconTooltip';

const useStyles = makeStyles({
  ...extendedFormsStyle,
  divider: {
    marginBottom: '20px',
  },
});

const MAX_BAG_LIMIT = 100;

const ClientPanel = ({ shopModule, setShopModule }) => {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <CardWrapper title={t('$*shop.clientPanel.title')}>
      <CardBody>
        <Divider className={classes.divider} />
        <GridContainer>
          <GridItem xs={12}>
            <LabeledCheckbox
              label={t('$*shop.clientPanel.showOnNewOrder')}
              checked={shopModule.clientPanelShowOnNewOrder}
              onChange={e => {
                setShopModule(prev => ({
                  ...prev,
                  clientPanelShowOnNewOrder: e.target.checked,
                }));
              }}
            />
          </GridItem>
          <GridItem xs={12}>
            <LabeledCheckbox
              label={t('$*shop.clientPanel.showOnCalendarDay')}
              checked={shopModule.clientPanelShowOnCalendarDay}
              onChange={e => {
                setShopModule(prev => ({
                  ...prev,
                  clientPanelShowOnCalendarDay: e.target.checked,
                }));
              }}
            />
          </GridItem>
          <GridItem xs={12}>
            <FormLabel className={classes.labelHorizontal}>
              {t('$*shop.clientPanel.bagLimit')}
              <InfoIconTooltip
                title={t('$*shop.clientPanel.bagLimit.tooltip')}
              />
            </FormLabel>
          </GridItem>
          <GridItem xs={2}>
            <NumberFormat
              classes={classes}
              customInput={FormTextInputNoGrid}
              format="###"
              value={shopModule.maximumDailyDishesForDietShop}
              onChange={e => {
                const validateValue = () => {
                  const value = e.target.value.trim();

                  if (value === '') {
                    return null;
                  }

                  // eslint-disable-next-line no-implicit-coercion -- FIXME
                  if (value !== '' && +value <= 0) {
                    return '1';
                  }

                  // eslint-disable-next-line no-implicit-coercion -- FIXME
                  if (+value > MAX_BAG_LIMIT) {
                    return String(MAX_BAG_LIMIT);
                  }

                  return value;
                };

                setShopModule(prev => ({
                  ...prev,
                  maximumDailyDishesForDietShop: validateValue(),
                }));
              }}
            />
          </GridItem>
        </GridContainer>
      </CardBody>
    </CardWrapper>
  );
};

export default ClientPanel;
